import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitterSquare, faInstagram, faRedditSquare } from '@fortawesome/free-brands-svg-icons';
import { useSelector } from 'src/client/redux';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { MenuLinkWrapper, MenuListWrapper, MenuTitle } from './FooterCategoryMenu';
import { TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';

export const FooterBarSocials = () => {
  const { config } = useSelector((state) => state.app);

  return (
    <SocialListWrapper>
      <SocialTitle className="hidden-xs">Social</SocialTitle>
      <SocialList className="list-unstyled">
        {config.twitter && (
          <SocialLinkWrapper>
            <a
              aria-label="Twitter"
              href={`https://twitter.com/${config.twitter}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faTwitterSquare} /> <span>Twitter</span>
            </a>
          </SocialLinkWrapper>
        )}
        {config.instagram && (
          <SocialLinkWrapper>
            <a
              aria-label="Instagram"
              href={`https://www.instagram.com/${config.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} /> <span>Instagram</span>
            </a>
          </SocialLinkWrapper>
        )}
        {config.reddit && (
          <SocialLinkWrapper>
            <a
              aria-label="Reddit"
              href={`https://www.reddit.com/r/${config.reddit}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faRedditSquare} /> <span>Reddit</span>
            </a>
          </SocialLinkWrapper>
        )}
        {config.hasBlog && config.featureFlags?.enableSeoCategoriesMenu && (
          <SocialLinkWrapper>
            <NavLink to="/blog">Blog</NavLink>
          </SocialLinkWrapper>
        )}
      </SocialList>
    </SocialListWrapper>
  );
};

const SocialListWrapper = styled(MenuListWrapper)`
  padding-top: 15px;
  text-align: center;

  @media ${TABLET_PORTRAIT} {
    padding-top: 0;
    text-align: left;
  }
`;

const SocialList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;

  @media ${TABLET_PORTRAIT} {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    line-height: 1.4;
  }
`;

const SocialTitle = styled(MenuTitle)`
  display: none;

  @media ${TABLET_PORTRAIT} {
    display: block;
  }
`;

const SocialLinkWrapper = styled(MenuLinkWrapper)`
  display: inline-flex;
  align-items: center;
  width: auto;

  a {
    line-height: 1.4;
    background: none;
    border: 0;
    padding: 0;
    font-size: 2.6rem;

    @media ${TABLET_PORTRAIT} {
      font-size: 0.9rem;
    }
  }

  span {
    display: none;

    @media ${TABLET_PORTRAIT} {
      display: inline;
      margin-left: 8px;
    }
  }

  svg {
    @media ${TABLET_PORTRAIT} {
      font-size: 0.9rem;
    }
  }
`;
